module.exports = __webpack_public_path__ + "img/banner.93d1ed25.png";